import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["choice", "feedback", "label", "correctIcon", "incorrectIcon"]
  static values = { correctLabel: String, incorrectLabel: String }

  choose(event) {
    const selected = event.currentTarget

    if (selected.checked) {
      this.choiceTargets.forEach((input) => {
        if (input !== selected) input.checked = false
      })
    }

    const active = this.choiceTargets.find((input) => input.checked)
    if (!active) {
      this.feedbackTarget.hidden = true
      return
    }

    const correct = active.dataset.correct === "true"
    this.labelTarget.textContent = correct ? this.correctLabelValue : this.incorrectLabelValue
    this.correctIconTarget.classList.toggle("d-none", !correct)
    this.incorrectIconTarget.classList.toggle("d-none", correct)
    this.feedbackTarget.hidden = false
  }
}
